<template>
  <div class="plv-ia__search__list__content">
    <ul
      v-if="searchListShow && switchOff"
      class="plv-ia-lottery__search__list"
    >
      <li
        v-for="(item, index) in searchList"
        :key="item.status"
        :class="{ 'plv-ia-choiced__option' : item.status && item.status === 'winner' }"
        @click="updateList('add', index)"
      >
        {{ item.nick }}
      </li>
    </ul>
    <ul
      v-if="winnerList.length > 0 && switchOff"
      class="plv-ia-lottery__preset__list"
    >
      <li
        v-for="(item, index) in winnerList"
        :key="item.nick"
      >
        {{ item.nick }}<span @click="updateList('del', index)"></span>
      </li>
    </ul>
  </div>
</template>

<script>
import Locale from '@/mixins/locale';
export default {
  mixins: [Locale],
  props: {
    searchList: {
      type: Array,
      default: () => []
    },
    amount: {
      type: Number,
      default: 0
    },
    switchOff: {
      type: Boolean,
      default: false
    },
  },

  data() {
    return {
      searchListShow: false,
      winnerListShow: false,
      winnerList: [],
      newSearchList: []
    };
  },

  watch: {
    searchList(val) {
      if (val.length <= 0) {
        this.newSearchList = [];
        this.searchListShow = false;
        return;
      }
      this.searchListShow = true;
      this.winnerListShow = false;
      this.newSearchList = val.concat();
      this.handleList(this.newSearchList);
    },
    switchOff(val) {
      // 关闭预设开关，返回初始状态
      const list = val ? this.winnerList : [];
      this.$emit('update-preset', list);
    }
  },

  methods: {
    handleList(data) {
      if (this.winnerList.length === 0) return data;
      data.forEach((item, index, arr) => {
        if (this.winnerList.some((val) => {
          return val.nick === item.nick;
        })) {
          arr[index].status = 'winner';
        } else {
          // 清空选中状态
          arr[index].status = null;
        }
      });
      return data;
    },

    clearWinnerList() {
      this.winnerList = [];
    },

    updateList(type, index) {
      if (type === 'add') {
        if (this.winnerList.length >= Number(this.amount)) {
          this.$iaMessage.default(this.t('plvIA.lottery.exceedWinners'));
          return;
        }
        const status = this.newSearchList[index].status;
        if (status && status === 'winner') {
          const nick = this.newSearchList[index].nick;
          this.winnerList.forEach((item, index, arr) => {
            if (item.nick === nick) arr.splice(index, 1);
          });
        } else {
          this.winnerList.push(this.searchList[index]);
        }
        this.searchListShow = false;
        this.winnerListShow = true;
        this.$emit('clear-search-input');
      } else {
        this.winnerList.splice(index, 1);
        this.handleList(this.searchList);
      }
      this.$emit('update-preset', this.winnerList);
    }
  }
};
</script>

<style lang="scss">
.plv-ia__search__list__content {
  width: 100%;
  text-align: left;
  background: #fff;
}
.plv-ia-lottery__preset__list {
  margin-bottom: 12px;

  >li {
    display: inline-block;
    height: 32px;
    line-height: 32px;
    margin: 0 8px 8px 0;
    padding: 0 8px;
    background: rgba(255, 255, 255, 1);
    border-radius: 2px;
    border: 1px solid rgba(32, 150, 243, 1);
    cursor: pointer;
    color: #2096F3;
    box-sizing: border-box;

    >span {
      width: 20px;
      height: 20px;
      vertical-align: middle;
      display: inline-block;
      padding-left: 4px;
      background-image: url(./images/icon-delete.png);
      background-size: cover;
    }
  }
}
.plv-ia-lottery__search__list {
  width: 320px;
  padding: 8px 8px 0;
  border: 1px solid #e0e0e0;

  >li {
    display: inline-block;
    margin: 0 8px 8px 0;
    padding: 0 8px;
    height: 32px;
    line-height: 30px;
    border: 1px solid #d3d3dd;
    cursor: pointer;
  }

  .plv-ia-choiced__option {
    color: #2196f3;
    border-color: #2196f3;
  }
}
</style>
